module.exports = __webpack_public_path__ + "img/footer-logo.cc50e5a.png";